export const ROUTE = 'cart/ROUTE';

export const route = () => ({ type: ROUTE });
